import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { toast } from "sonner";

export default function Pricing() {
  const { user, refresh } = useAuth();
  const [plans, setPlans] = useState([]);

  useEffect(() => { api.get("/subscription/plans").then(({ data }) => setPlans(data)); }, []);

  const upgrade = async (planId) => {
    if (!user) { toast.error("Login to upgrade"); return; }
    await api.post(`/subscription/upgrade?plan_id=${planId}`);
    toast.success(`Upgraded to ${planId.toUpperCase()} (mock)`);
    refresh();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
      <div className="text-center max-w-xl mx-auto">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E] mb-3">◇ Membership</div>
        <h1 className="font-heading text-5xl sm:text-6xl tracking-tight">Plans for every curator.</h1>
        <p className="font-body text-[#595959] mt-4">Start free, upgrade when you outgrow it. Cancel anytime.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 mt-16 border border-[#E5E5E5]">
        {plans.map((p, i) => {
          const isCurrent = user?.plan === p.id;
          const featured = p.id === "plus";
          return (
            <div key={p.id} data-testid={`plan-${p.id}`} className={`p-10 ${i > 0 ? "md:border-l border-[#E5E5E5]" : ""} ${featured ? "bg-[#333333] text-white" : "bg-white"}`}>
              <div className={`font-mono text-[10px] uppercase tracking-[0.3em] ${featured ? "text-[#9CA47E]" : "text-[#9CA47E]"}`}>{p.id}</div>
              <h2 className="font-heading text-4xl mt-2">{p.name}</h2>
              <div className="font-heading text-5xl mt-6">${p.price}<span className="font-body text-base text-[#595959]">/{p.period}</span></div>
              <ul className="mt-8 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className={`flex items-start gap-3 font-body text-sm ${featured ? "text-white/85" : "text-[#333333]"}`}>
                    <Check className="w-4 h-4 mt-0.5 shrink-0" /> {f}
                  </li>
                ))}
              </ul>
              <Button
                data-testid={`upgrade-${p.id}`}
                disabled={isCurrent}
                onClick={() => upgrade(p.id)}
                className={`rounded-none w-full mt-10 py-6 ${featured ? "bg-[#9CA47E] hover:bg-[#7E876A] text-white" : "bg-[#333333] hover:bg-[#333] text-white"}`}
              >
                {isCurrent ? "Current plan" : `Choose ${p.name}`}
              </Button>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-12 font-mono text-[10px] uppercase tracking-[0.3em] text-[#595959]">
        ⌗ Mocked checkout — Stripe integration available on request.
      </div>
    </div>
  );
}
